var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import client from 'api/environment';
import CLEAN_DATA from 'api/mutations/CLEAN_DATA';
import LOAD_ONE_SPECIFICATION_DATA from 'api/mutations/LOAD_ONE_SPECIFICATION_DATA';
import LOAD_TEST_DATA from 'api/mutations/LOAD_TEST_DATA';
export const initialState = {
    status: {
        cleanData: 'idle',
        loadTestData: 'idle',
        loadOneSpecificationData: 'idle',
    },
    errors: {
        cleanData: null,
        loadTestData: null,
        loadOneSpecificationData: null,
    },
};
export const cleanData = createAsyncThunk('maintenance/cleanData', (_a) => __awaiter(void 0, [_a], void 0, function* ({ runSeed }) {
    try {
        const data = yield client.mutate({
            mutation: CLEAN_DATA,
            variables: {
                runSeed,
            },
            fetchPolicy: 'no-cache',
        });
        return data;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const loadTestData = createAsyncThunk('maintenance/loadTestData', () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const data = yield client.mutate({
            mutation: LOAD_TEST_DATA,
            fetchPolicy: 'no-cache',
        });
        return data;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const loadOneSpecificationData = createAsyncThunk('maintenance/loadOneSpecificationData', () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const data = yield client.mutate({
            mutation: LOAD_ONE_SPECIFICATION_DATA,
            fetchPolicy: 'no-cache',
        });
        return data;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
const maintenanceSlice = createSlice({
    name: 'maintenance',
    initialState,
    reducers: {
        resetMaintenance() {
            return initialState;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(cleanData.pending, (state) => {
            state.status.cleanData = 'loading';
        })
            .addCase(cleanData.fulfilled, (state) => {
            state.status.cleanData = 'succeeded';
        })
            .addCase(cleanData.rejected, (state, action) => {
            state.status.cleanData = 'failed';
            state.errors.cleanData = action.error.message || 'Failed to add specification';
        })
            .addCase(loadTestData.pending, (state) => {
            state.status.loadTestData = 'loading';
        })
            .addCase(loadTestData.fulfilled, (state) => {
            state.status.loadTestData = 'succeeded';
        })
            .addCase(loadTestData.rejected, (state, action) => {
            state.status.loadTestData = 'failed';
            state.errors.loadTestData = action.error.message || 'Failed to add specification';
        })
            .addCase(loadOneSpecificationData.pending, (state) => {
            state.status.loadOneSpecificationData = 'loading';
        })
            .addCase(loadOneSpecificationData.fulfilled, (state) => {
            state.status.loadOneSpecificationData = 'succeeded';
        })
            .addCase(loadOneSpecificationData.rejected, (state, action) => {
            state.status.loadOneSpecificationData = 'failed';
            state.errors.loadOneSpecificationData =
                action.error.message || 'Failed to add specification';
        });
    },
});
export const { resetMaintenance } = maintenanceSlice.actions;
export const selectMaintenanceStatus = (state) => state.parameters.maintenance.status;
export const selectMaintenanceErrors = (state) => state.parameters.maintenance.errors;
export default maintenanceSlice.reducer;
